/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { MaterialReactTable } from 'material-react-table'
// import { Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ExportCsv from '../../Controls/ExportCsv'
// import Papa from 'papaparse'
import { Dialog, DialogContent, DialogContentText, DialogActions, Button, TableContainer } from '@material-ui/core'
import { useMergeState } from 'irmlib/hooks'

const initialState = {
  selectedImage: null
}

const TransmittalMaterialTable = (props) => {
  const { t } = useTranslation()
  const [, setState, getState] = useMergeState(initialState)
  // const [rowSelected, setRowSelected] = useState({})
  const [selectedRow, setSelectedRow] = useState(null)

  // useEffect(() => {
  //   onSelectionChange()
  // }, [rowSelected])

  const columns = [
    {
      header: t('tableColumns.templateId'),
      accessorKey: 'templateId',
      grow: true,
    },
    {
      header: t('tableColumns.customTemplateName'),
      accessorKey: 'customTemplateName',
      grow: true,
      minSize: 250,
    },
    {
      header: t('templates.createdBy'),
      accessorKey: 'createdBy',
      grow: true,
    },
    {
      header: t('tableColumns.templateFields'),
      accessorKey: 'requestFields',
      grow: true,
      minSize: 500,
    },
    {
      header: t('tableColumns.imgReference'),
      accessorKey: 'imgReference',
      grow: true,
      Cell: ({ row }) => (
        row.original.imgReference
          ? (
            <img
              src={row.original.imgReference}
              alt="Reference"
              style={{ width: '100px', height: '70px', cursor: 'pointer', paddingLeft: '10px' }}
              onClick={() => setState({ selectedImage: row.original.imgReference })}
            />
            )
          : null
      ),
    }
  ]

  const handleClose = () => {
    setState({ selectedImage: null })
  }

  const ImageContainer = () => {
    return (
      <Dialog open={!!getState().selectedImage} onClose={handleClose}>
        <DialogContent>
          <DialogContentText>
            <img
              src={getState().selectedImage}
              alt="Box Image"
              style={{ width: '100%', height: 'auto', maxWidth: '400px', maxHeight: '400px' }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  // const onSelectionChange = (row) => {
  //   const isSelected = selectedRow?.id === row.id
  //   const newSelectedRow = isSelected ? null : row
  //   setSelectedRow(newSelectedRow)
  //   setRowSelected(row)
  //   props.handleSelectedRows(newSelectedRow ? newSelectedRow?.original : null)
  // }

  const onSelectionChange = (row) => {
    if (JSON.stringify(row) !== '{}') {
      // props.handleSelectedRows(rowSelected?.original?.templateId)
      props.handleSelectedRows(row?.original)
    }
  }

  const columnsWithWidths = columns.map((col) => {
    return {
      ...col,
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
        }
      },
    }
  })

  return (
    <>
      <TableContainer>
        <MaterialReactTable
          muiTableHeadCellProps={{
            sx: {
              color: '#58595B',
              fontWeight: 'bold',
            },
          }}
          columns={columnsWithWidths}
          // options={options}
          data={props.data}
          enableRowSelection
          enableExport={true}
          enableGlobalFilter
          enableColumnFilter
          enableColumnSorting
          enableGrouping={true}
          enableColumnResizing={true}
          positionToolbarAlertBanner='none'
          state={{ rowSelection: selectedRow ? { [selectedRow]: true } : {} }}
          muiSelectCheckboxProps={({ row }) => ({
            checked: selectedRow === row.id,
            onChange: (e) => {
              if (!e.target.checked) {
                props.handleSelectedRows(null)
              } else {
                onSelectionChange(row)
              }
              setSelectedRow(selectedRow === row.id ? null : row.id)
              // setRowSelected(row)
            }
            // onChange: () => onSelectionChange(row)
          })}
          handleSelectedRows={props.handleSelectedRows}
          initialState={{ columnVisibility: { imgReference: true, modify: true }, density: 'compact' }}

          renderTopToolbarCustomActions={({ table }) => {
            const isDisabled = !table.getIsSomeRowsSelected()
            const isNoData = props.data?.length === 0
            const isNoPageData = !props.data?.length > 4
            return (
              <ExportCsv
                columns={columns}
                isDisabled={isDisabled}
                isNoData={isNoData}
                isNoPageData={isNoPageData}
                table={table}
              />
            )
          }}
          tableFor='smart_catalog_view_Templates'
        />
      </TableContainer>
      <ImageContainer />
    </>
  )
}

export default TransmittalMaterialTable